export const __ENV__ = `${process.env.NODE_ENV}`.toUpperCase();
export const __DEV__ = __ENV__ === 'DEVELOPMENT';
export const __PRODUCTION__ = __ENV__ === 'PRODUCTION';
export const __RELEASE_ID__ = `${process.env.NEXT_PUBLIC_RELEASE_ID}`;
